export default "/site/aidive/js/react/dist/images/pao-hero-bg-mobile.ecd51230.webp";